export function getApiBaseUrl() {
  if (typeof window !== 'undefined') {
    const currentPath = window.location.href;
    if (currentPath.includes('alpha')) {
      return 'https://robocalls.optum-pes-alpha.net/robocalloptoutin/v1';
    } else if (currentPath.includes('stage')) {
      // return 'https://robocalls.optum-pes-stage.net/robocalloptoutin/v1';
      return '/robo-api';
    } else if (currentPath.includes('localhost')) {
      // return 'https://robocalls.optum-pes-alpha.net/robocalloptoutin/v1';
      return '/robo-api';
    } else if (currentPath.includes('prod')) {
      return 'https://robocalls.optum-pes-prod.net/robocalloptoutin/v1';
    }
  }

  return '';
}
